import React, { useEffect, useState, useCallback } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useParams } from "react-router";

import { SEVERITY } from '../../utils/Snackbar';
import { get, put } from '../../utils/Api';
import { formatarData } from '../../utils/Formatters';
import CamposToolbar from '../../toolbars/CamposToolbar';
import Campo from '../Campo';
import Header from '../../toolbars/Header';

export default function Campos({
  version,
  setLoading,
  handleMessage,
  mainError,
  setError
}) {
  const { documentoUUID } = useParams();

  const [documento, setDocumento] = useState({
    documento_uuid: '',
    documento_nome: '',
    documento_nome_cliente: '',
    genero_uuid: '',
    data_criacao: '',
    data_alteracao: '',
    modelo_uuid: '',
    modelo_nome: '',
    modelo_versao: 0,
    situacao_uuid: '',
    situacao_nome: '',
    situacao_variavel: '',
  });

  const [campos, setCampos] = useState([]);
  const [indexCampos, setIndexCampos] = useState({});
  const [camposSubmit, setCamposSubmit] = useState([]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (mainError) { return; }
    setLoading(true);

    /* Cria cópia rasa */
    const documentoLocal = { ...documento };
    const camposLocal = structuredClone(campos);
    // camposLocal[0].valor.valor_definido = '';

    /* Obter valores do submit */
    const data = new FormData(event.currentTarget);

    /* Valores do documento */
    documentoLocal.documento_nome = data.get('documento_nome');
    documentoLocal.documento_nome_cliente = data.get('documento_nome_cliente');

    /* Obter valores dos campos */
    for (const [indexCamposSubmit, campoSubmit] of camposSubmit.entries()) {
      const index = indexCampos[campoSubmit];
      const campo = camposLocal[index];
      const valor = data.get(campoSubmit);

      if (campoSubmit in documentoLocal) {
        documentoLocal[campoSubmit] = valor;
      } else {
        setCampos(estadoAnterior =>
          estadoAnterior.map(entry => {
            // 1. Encontra o item que você quer modificar
            if (entry.uuid === campo.uuid) {
              return {
                ...entry, // Copia as propriedades do produto (como id e nome)
                valor: {
                  ...entry.valor, // Copia as propriedades do subdict anterior
                  valor_definido: valor // Atualiza apenas a propriedade desejada
                }
              };
            }
            // 2. Retorna os outros itens sem alteração
            return entry;
          })
        );
        camposLocal[index].valor.valor_definido = valor;
      }

      if (indexCamposSubmit === (camposSubmit.length - 1)) {
        documentoLocal.campos = camposLocal;
        salvarDocumento(documentoLocal);
      }
    }
    /* Obter valores dos campos */
  };

  const handleAlterarDocumento = (documento_uuid,situacao,callback) => {
    if (mainError) { callback(false,situacao); return; }

    if (situacao.situacao_nome === 'Revisado') {
      put(`api/documento/${documento_uuid}/alterar`,{},(json)=>{
        situacao.situacao_uuid = json.situacao.situacao_uuid;
        situacao.situacao_nome = json.situacao.situacao_nome;
        situacao.situacao_variavel = json.situacao.situacao_variavel;
        callback(true,situacao);
      },()=>{
        handleMessage('Falha ao atualizar situação do documento!',SEVERITY.WARNING.toString(),'',false);
        callback(false,situacao);
      });
    } else {
      callback(true,situacao);
    }
  };

  const handleChange = (
      valor_uuid,
      valor_opcao_uuid,
      event,
  ) => {

    const campo_variavel = event.target.name;
    const valor_definido = event.target.value;

    if ((campo_variavel in documento) && (valor_uuid === null)) {
      setDocumento((dados) => ({
        ...dados,
        [campo_variavel]: valor_definido,
      }));
    } else {
      setCampos((prevCampos) => {
        const newCampos = [...prevCampos];
        const index = indexCampos[campo_variavel];
        const campo = newCampos[index];

        let novo_valor_definido = '';
        if ((campo.opcoes.length > 0) && !campo_variavel.includes("#valor")) {
          novo_valor_definido = campo.opcoes.find(
            opcao=>opcao.opcao_uuid === (
              (valor_opcao_uuid === null) ? campo.valor.valor_opcao_uuid : valor_opcao_uuid
            )
          ).opcao_texto_exibido;
        } else if (campo.tipo_campo_nome === 'datePicker') {
          novo_valor_definido = valor_definido.format('YYYY-MM-DDTHH:mm:ss');
        } else {
          novo_valor_definido = valor_definido;
        }

        newCampos[index] = {
          ...prevCampos[index],
          valor: {
            ...campo.valor,
            valor_opcao_uuid: ((valor_opcao_uuid === null) ? campo.valor.valor_opcao_uuid : valor_opcao_uuid),
            valor_definido: novo_valor_definido
          }
        };
        return newCampos;
      });
    }
  };

  const obterPai = (documento,campo) => {
    return campos.find(entry => entry.campo_uuid === campo.campo_pai_uuid) ?? { campo_pai_uuid: '', opcoes: [], valor: { valor_opcao_uuid: '' } };
  };

  const verificarRespostaSim = (pai) => {
    return ( (pai.opcoes.find(opcao => opcao.opcao_nome === 'Sim') ?? { opcao_uuid: '' }).opcao_uuid === pai.valor.valor_opcao_uuid);
  };

  const verificarRespostaNao = (documento,pai,callback) => {
    if ((pai.campo_pai_uuid !== null) && (pai.campo_pai_uuid !== '')) {
      const avo = obterPai(documento,pai);
      verificarRespostaNao(documento,avo,callback);
    } else {
      callback((pai.opcoes.find(opcao => opcao.opcao_nome === 'Não') ?? { opcao_uuid: '' }).opcao_uuid === pai.valor.valor_opcao_uuid);
    }
  };

  const limparValorFilhoNaoExibido = (documento,campo,callback) => {
    if ((campo.campo_pai_uuid !== null) && (campo.campo_pai_uuid !== '')) {

      /* Obter o campo Pai */
      const pai = obterPai(documento,campo);

      /* Verificar se pai foi marcado como Não */
      verificarRespostaNao(documento,pai,(foi_marcado_nao)=>{

        /* Se o Pai foi marcado como Não, limpar filho */
        if (foi_marcado_nao) {
          campo.valor.valor_definido = '';
          campo.valor.valor_opcao_uuid = '';
        }

        callback();
      });

    } else {
      callback();
    }
  }

  const limparValorFilhosNaoExibidos = (documento,callback) => {
    /* Percorrer todos os campos */
    for (const [index, campo] of campos.entries()) {
      limparValorFilhoNaoExibido(documento,campo,()=>{
        if (index === (campos.length - 1)) {
          callback();
        }
      });
    }
  }

  const preencherEstados = useCallback((json,callback) => {
    setDocumento((dados) => ({
      ...dados,
      documento_uuid: json.documento_uuid,
      documento_nome: json.documento_nome,
      documento_nome_cliente: json.documento_nome_cliente,
      genero_uuid: json.genero_uuid,
      modelo_uuid: json.modelo_uuid,
      modelo_nome: json.modelo_nome,
      modelo_versao: json.modelo_versao,
      data_criacao: formatarData(json.data_criacao),
      data_alteracao: formatarData(json.data_alteracao),
      situacao_uuid: json.situacao_uuid,
      situacao_nome: json.situacao_nome,
      situacao_variavel: json.situacao_variavel,
    }));
    setCampos(json.campos);

    let emptyIndexCampos = {};
    let emptyCamposSubmit = [];

    for (const [index, campo] of json.campos.entries()) {

      emptyIndexCampos[campo.campo_variavel] = index;

      if (campo.campo_valor_submit) {
        emptyCamposSubmit.push(campo.campo_variavel);
      }

      if (index === (json.campos.length - 1)) {
        setIndexCampos((prevIndexCampos) => ({
          ...prevIndexCampos,
          ...emptyIndexCampos
        }));
        setCamposSubmit(emptyCamposSubmit);

        callback();
      }
    }
  }, []);

  const salvarDocumento = (documentoSubmit) => {
    if (mainError) { return; }

    let situacao = {
      situacao_uuid: documentoSubmit.situacao_uuid,
      situacao_nome: documentoSubmit.situacao_nome,
      situacao_variavel: documentoSubmit.situacao_variavel,
    };

    handleAlterarDocumento(documentoSubmit.documento_uuid,situacao,(sucessoAlterado,situacaoAlterada)=>{
      if (sucessoAlterado) {
        documentoSubmit.situacao_uuid = situacaoAlterada.situacao_uuid;
        documentoSubmit.situacao_nome = situacaoAlterada.situacao_nome;
        documentoSubmit.situacao_variavel = situacaoAlterada.situacao_variavel;

        limparValorFilhosNaoExibidos(documentoSubmit,()=>{

          put(`api/documento/${documentoUUID}`,documentoSubmit,(json,message,severity)=>{

            preencherEstados(json,()=>{
              setLoading(false);
              handleMessage('Documento salvo com sucesso!',severity,'',false);
            });

          },(error,message,severity)=>{
            setLoading(false);
            handleMessage(message,severity,error,true);
          });
        });
      }
    });

  };

  useEffect(()=>{
    if (mainError) { return; }

    setLoading(true);
    get(`api/documento/${documentoUUID}`,(json)=>{

      preencherEstados(json,()=>{
        setLoading(false);
      });

    },(error,message,severity)=>{
      handleMessage(message,severity,error,true);
      setLoading(false);
    });

  },[]);

  const cssGrid = {
    backgroundColor: '#fafafa',
    paddingRight: '14px',
    paddingLeft: '14px',
    paddingBottom: '10px',
    paddingTop: '16px',
    marginBottom: '16px',
    borderRadius: '5px',
    boxShadow: '0 0 3px 2px rgba(0, 0, 0, 0.2)',
  };

  const cssGridModelo = {
    backgroundColor: '#fafafa',
    paddingRight: '14px',
    paddingLeft: '14px',
    paddingBottom: '10px',
    paddingTop: '16px',
    marginBottom: '16px',
    borderRadius: '5px',
    boxShadow: '0 0 3px 2px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    gap: 2,
    alignItems: 'center',
  };

  const mostrarCampo = (documento,campo) => {

    /* Buscar o pai */
    const pai = obterPai(documento,campo);

    /* Verificar se pai foi marcado como Sim */
    const foi_marcado_sim = verificarRespostaSim(pai);

    /* Verificar se filho possui pai */
    const primeira_parte = (campo.campo_pai_uuid === null);

    /* Se filho não possui pai OU pai foi marcado como Sim, exibir campo filho */
    let retorno = false;
    if (
      primeira_parte || (
        !primeira_parte && foi_marcado_sim
      )
    ) retorno = true;

    /* Verificar se Avo esta marcado como Sim */
    if ((pai.campo_pai_uuid !== null) && (pai.campo_pai_uuid !== '')) {
      retorno = mostrarCampo(documento,pai);
    }

    return retorno;
  };

  return (
    <React.Fragment>
      <Header
        clear={() => this.content.clearSelection()}
        version={version}
        setLoading={setLoading}
        handleMessage={handleMessage}
        error={mainError}
        setError={setError}>
      </Header>

      <Box
        component="form"
        onSubmit={handleSubmit}
        noValidate
        autoComplete="off"
        sx={{
          position: 'absolute',
          top: '64px',
          bottom: '0',
          left: '0',
          right: '0',
        }}>
        <CamposToolbar
          documentoUUID={documentoUUID}
          documento={documento}
        />
        <Paper
          sx={{
            position: 'absolute',
            top: '72px',
            bottom: '8px',
            left: '8px',
            right: '8px',
            overflowY: 'scroll',
            borderTopLeftRadius: '0',
            borderTopRightRadius: '0',
          }}>
          <Box
            sx={{
              width: { xs: 'auto', sm: '800px' },
              padding: { xs: 0, sm: '20px 20px 20px 44px' },
              border: 0,
              marginTop: 2,
              margin: '0 auto',
            }}>

            <Grid container spacing={0}
              sx={{
                marginTop: 0.5,
              }}>

              <Grid item="true" size={12} sx={cssGridModelo}>
                <TextField
                  fullWidth
                  sx={{ flexGrow: 1 }}
                  disabled
                  slotProps={{ inputLabel: { shrink: true } }}
                  id="modelo_nome"
                  name="modelo_nome"
                  label="Modelo do Documento"
                  value={documento.modelo_nome}
                />
                <TextField
                  disabled
                  sx={{
                    width: '100px',
                  }}
                  slotProps={{
                    inputLabel: { shrink: true },
                    htmlInput: { style: { textAlign: 'center' } },
                  }}
                  id="modelo_versao"
                  name="modelo_versao"
                  label="Versão"
                  value={`v${documento.modelo_versao}`}
                />
              </Grid>

              <Grid item="true" size={12} sx={cssGrid}>
                <TextField
                  fullWidth
                  required
                  slotProps={{ inputLabel: { shrink: true } }}
                  id="documento_nome"
                  name="documento_nome"
                  label="Nome do Documento"
                  defaultValue={documento.documento_nome}
                />
              </Grid>
              <Grid item="true" size={12} sx={cssGrid}>
                <TextField
                  fullWidth
                  required
                  slotProps={{ inputLabel: { shrink: true } }}
                  id="documento_nome_cliente"
                  name="documento_nome_cliente"
                  label="Nome do Cliente"
                  defaultValue={documento.documento_nome_cliente}
                />
              </Grid>
              <Grid item="true" size={12} sx={cssGrid}>
                <TextField
                  fullWidth
                  slotProps={{ inputLabel: { shrink: true } }}
                  id="data_criacao"
                  name="data_criacao"
                  label="Data de Criação"
                  value={documento.data_criacao}
                  disabled
                />
              </Grid>

              {campos.map((campo,index) => (

                mostrarCampo(documento,campo) ? (
                  <Campo
                    key={`${campo.campo_variavel}-${index}`}
                    campo={campo}
                    handleChange={handleChange}
                    cssGrid={cssGrid}
                  />
                ) : (
                  <React.Fragment
                    key={`${campo.campo_variavel}-${index}`}>
                  </React.Fragment>
                )

              ))}

            </Grid>

          </Box>

          <Box sx={{
            height: { xs: '90px', sm: 0 },
          }}></Box>
        </Paper>
      </Box>
    </React.Fragment>
  );
}
